import { CSS } from '@dnd-kit/utilities';

import { CRITICALITY_BADGES, PRIORITY_BADGES } from '../../../utilities/consts';

export const getEventCardStyle = ({ isDragOverlay, transform, transition, isDragging }) => {
  if (isDragOverlay) return undefined;
  return {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.3 : 1,
  };
};

export const eventCardStyles = {
  card: ({ isPending, isDragOverlay }) => ({
    border: isPending ? '1px dashed' : '1px solid',
    borderColor: isPending ? 'warning.light' : 'divider',
    transition: 'opacity 0.2s ease',
    '&:hover': { backgroundColor: 'action.hover' },
    ...(isDragOverlay && { boxShadow: 6, cursor: 'grabbing' }),
  }),
  content: { py: 2 },
  row: { display: 'flex', alignItems: 'center', gap: 2 },
  dragHandle: (isDragOverlay) => ({ cursor: isDragOverlay ? 'grabbing' : 'grab', display: 'flex' }),
  dragIcon: { color: 'text.secondary', '&:hover': { color: 'text.primary' } },
  orderBadge: (isPending) => ({
    backgroundColor: isPending ? 'warning.light' : 'primary.main',
    color: 'white',
    borderRadius: '50%',
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.75rem',
    fontWeight: 'bold',
    minWidth: 24,
    flexShrink: 0,
  }),
  eventText: { flex: 1, minWidth: 0 },
  titleRow: { display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 },
  commonPriorityBadge: {
    fontSize: 11,
    fontWeight: 700,
    borderRadius: 1,
    border: '1px solid',
    px: 0.5,
    lineHeight: 1.4,
    flexShrink: 0,
  },
  priorityBadge: (priority) => ({
    ...eventCardStyles.commonPriorityBadge,
    color: PRIORITY_BADGES[priority] || 'primary.main',
    borderColor: PRIORITY_BADGES[priority] || 'primary.main',
  }),
  criticalityBadge: (criticality) => ({
    ...eventCardStyles.commonPriorityBadge,
    // width: 'fit-content',
    textAlign: 'center',
    borderColor: CRITICALITY_BADGES[criticality] || 'primary.main',
    color: CRITICALITY_BADGES[criticality] || 'primary.main',
  }),
  pendingLabel: { color: 'warning.main', fontSize: '0.75rem' },
  actions: { display: 'flex', gap: 1 },
  editButton: { color: 'primary.main' },
};
